import { useCallback, useState } from 'react';
const minSwipeDistance = 50;
export const useSwipe = ({ onSwipedLeft, onSwipedRight }) => {
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const onTouchStart = useCallback((e) => {
        setTouchEnd(0);
        e.targetTouches[0] && setTouchStart(e.targetTouches[0].clientX);
    }, []);
    const onTouchMove = useCallback((e) => e.targetTouches[0] && setTouchEnd(e.targetTouches[0].clientX), []);
    const onTouchEnd = useCallback(() => {
        if (!touchStart || !touchEnd)
            return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        if (isLeftSwipe) {
            onSwipedLeft();
        }
        if (isRightSwipe) {
            onSwipedRight();
        }
    }, [onSwipedLeft, onSwipedRight, touchEnd, touchStart]);
    return {
        onTouchStart,
        onTouchMove,
        onTouchEnd,
    };
};
//# sourceMappingURL=useSwipe.js.map